var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCameraWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.33335V0.833355H4.16667V3.33335H6.66667V5.00002H4.16667V7.50002H2.5V5.00002H0V3.33335H2.5ZM5 8.33335V5.83335H7.5V3.33335H13.3333L14.8583 5.00002H17.5C18.4167 5.00002 19.1667 5.75002 19.1667 6.66669V16.6667C19.1667 17.5834 18.4167 18.3334 17.5 18.3334H4.16667C3.25 18.3334 2.5 17.5834 2.5 16.6667V8.33335H5ZM10.8333 15.8334C13.1333 15.8334 15 13.9667 15 11.6667C15 9.36669 13.1333 7.50002 10.8333 7.50002C8.53333 7.50002 6.66667 9.36669 6.66667 11.6667C6.66667 13.9667 8.53333 15.8334 10.8333 15.8334ZM8.16667 11.6667C8.16667 13.1417 9.35833 14.3334 10.8333 14.3334C12.3083 14.3334 13.5 13.1417 13.5 11.6667C13.5 10.1917 12.3083 9.00002 10.8333 9.00002C9.35833 9.00002 8.16667 10.1917 8.16667 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraWhite);
export default __webpack_public_path__ + "static/media/icon-camera-white.60dd6e146e6e2d81f4fd6709af312b9a.svg";
export { ForwardRef as ReactComponent };